import { Modal } from 'antd';
import { AppState } from 'interface/stateApp';
import QaReport from './QaReport';

interface FormProps {
  stateApp: AppState;
  setStateApp: React.Dispatch<React.SetStateAction<AppState>>;
  ticket?: any;
  onData?: any;
}

export default function QaReportModal({ stateApp, setStateApp, ticket, onData }: FormProps) {
  const { showReportForm } = stateApp;
  return (
    <Modal
      open={showReportForm}
      onCancel={() =>
        setStateApp({
          ...stateApp,
          showReportForm: false,
        })
      }
      footer={[]}
      className="mx-auto w-full md:!w-[550px] rounded-full"
    >
      <div className="p-[2px]">
        <QaReport stateApp={stateApp} setStateApp={setStateApp} ticket={ticket} onData={onData}></QaReport>
      </div>
    </Modal>
  );
}
